import { Autocomplete, TextField } from "@mui/material"

export function ConditionValueCodePicker({ value, onChange, operator, placeholder }) {
    const isSingle = operator === "starts with"

    if (isSingle) {
        return (
            <TextField
                fullWidth
                value={Array.isArray(value) ? value[0] || "" : value || ""}
                onChange={handleTextChange}
                placeholder={placeholder || "Enter code prefix..."}
            />
        )
    }

    const selected = Array.isArray(value) ? value : value ? [value] : []

    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={selected}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField {...params} placeholder={placeholder || "Type codes and press Enter..."} />
            )}
        />
    )

    function handleTextChange(e) {
        onChange(e.target.value)
    }

    function handleChange(_, newValue) {
        onChange(newValue)
    }
}
